<app-navbar></app-navbar>

<div class="container mt-4 pt-3 position-relative">
  <router-outlet></router-outlet>
</div>
<app-toast></app-toast>